import type React from 'react';

import { parseHtml } from '@change-corgi/core/react/html';
import { InlineMessage } from '@change-corgi/design-system-legacy/components/alerts';
import { Box } from '@change-corgi/design-system-legacy/layout';

import type { SessionUser } from 'src/shared/session';

import { FacebookButton } from './components/FacebookButton';
import { GoogleButton } from './components/GoogleButton';
import { useLoginModalSocialAuth } from './hooks/useLoginModalSocialAuth';

type Props = {
	googleAuthEnabled: boolean;
	onSuccess: (user: SessionUser) => void;
};

export const LoginModalSocialAuth: React.FC<Props> = ({ onSuccess, googleAuthEnabled }) => {
	const {
		data: { error },
		actions: { handleError },
	} = useLoginModalSocialAuth();

	return (
		<>
			{error && (
				<InlineMessage variant="error" mb={16} px={8}>
					{parseHtml(error)}
				</InlineMessage>
			)}
			{googleAuthEnabled && (
				<Box mb={16}>
					<GoogleButton onSuccess={onSuccess} onError={handleError} />
				</Box>
			)}
			<Box>
				<FacebookButton onSuccess={onSuccess} onError={handleError} />
			</Box>
		</>
	);
};
